import './utilisateurs.scss';
import React, { useEffect, useState } from 'react';
import AppelerApi from '../../../services/appeler-api.service';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';


const Utilisateurs = () => {

    const [valeurEntree, _] = useState('');
    let [saisieNouveauLogin, setNouveauLogin] = useState('');
    let [motDePasseOuvert, ouvrirMotDePasse] = useState(null);
    let [utilisateurs, setUtilisateurs] = useState([]);
    const droits = ['Acces_Preprod', 'Droit_Donnees_Client', 'Droit_Donnees_Admin', 'Droit_Deploiement', 'Droit_Fonctionnalites', 'Droit_Infrastructure', 'Droit_Imports', 'Droit_Copie', 'Droit_Creation', 'Droit_Utilisateurs'];

    const enregistrerNouvelUtilisateur = () => {
        AppelerApi.post('/creer-utilisateur', { login: saisieNouveauLogin }).then(res => {
            setNouveauLogin('');
            ouvrirMotDePasse(res.motDePasse);
            AppelerApi.get('/lire-utilisateurs').then(res => {
                setUtilisateurs(res.utilisateurs);
            });
        });
    };

    const activerDroit = (index, droit, event) => {
        const valeur = event.target.checked;
        const utilisateurModifie = JSON.parse(JSON.stringify(utilisateurs[index]));
        utilisateurModifie[droit] = valeur;
        const nouvelleListe = Object.assign([ ...utilisateurs], { [index]: utilisateurModifie });
        setUtilisateurs(nouvelleListe);
        AppelerApi.post('/modifier-droit-utilisateur', { utilisateur: utilisateurModifie.Identifiant_utilisateur, droit: droit, valeur: valeur }).then(() => {});
    };

    useEffect(() => {
        AppelerApi.get('/lire-utilisateurs').then(res => {
            setUtilisateurs(res.utilisateurs);
        });
    }, [valeurEntree]);

    return (
        <div className="conteneur-utilisateurs">
            <h1>Gestion des utilisateurs</h1>
            <div className="bloc-fonctionnel">
                <div className="parametres-nouvel-utilisateur">
                    <TextField placeholder="Login nouvel utilisateur" onChange={e => setNouveauLogin(e.target.value) }/>
                    <Button onClick={enregistrerNouvelUtilisateur} disabled={!saisieNouveauLogin.length === 0}>Créer</Button>
                </div>
            </div>
            <div className="bloc-fonctionnel">
            {
                utilisateurs.length > 0 &&
                (<div className="tableau-utilisateurs"><table>
                    <thead>
                        <tr>
                            <th scope="col">Utilisateur</th>
                            {droits.map(droit =>
                                <th key={droit} scope="col">{droit}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(utilisateurs).map(([index, utilisateur]) =>
                            <tr key={utilisateur.Identifiant_utilisateur}>
                                <td>{utilisateur.Identifiant_utilisateur}</td>
                                {droits.map(droit =>
                                    <td key={utilisateur.Identifiant_utilisateur + '_' + droit}>
                                        <Checkbox
                                            checked={!!utilisateur[droit]}
                                            onChange={e => activerDroit(index, droit, e)}
                                        />
                                    </td>
                                )}
                            </tr>
                        )}
                    </tbody>
                </table></div>)
                }
            </div>
            <Dialog
                open={motDePasseOuvert !== null}
                onClose={() => { ouvrirMotDePasse(null) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle>Utilisateur créé</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Voici le nouveau mot de passe de l'utilisateur, veuillez le copier, il ne se sera fourni qu'une fois :<br/>
                        {motDePasseOuvert}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { ouvrirMotDePasse(null) }}>Fermer</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Utilisateurs;